import { render, staticRenderFns } from "./TemplateMethodsPopover.vue?vue&type=template&id=279a7bf4&"
import script from "./TemplateMethodsPopover.vue?vue&type=script&lang=js&"
export * from "./TemplateMethodsPopover.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMethodsPopover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports